import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';

import { AuthContext } from '../contexts/AuthContext';

export default function SideMenuUserProfile() {
  const { userRole } = useContext(AuthContext);
  const authCtx = useContext(AuthContext);

  return (
    <Stack
      direction="column"
      sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
      <Typography
        variant="body2"
        sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
        {authCtx.merchantName}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
        }}>
        {userRole}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
        }}>
        {authCtx.userEmail}
      </Typography>
    </Stack>
  );
}
